// extracted by mini-css-extract-plugin
export default {"privacy_policy":"PrivacyPolicy_privacy_policy__Tic-M"};